module.exports = __webpack_public_path__ + "static/img/QR.beecf251.png";